export default __webpack_public_path__ + "assets/cr_logo_default.c80962c5841cfa372b7cc6ba90bb2c0b.svg";